var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeesEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.292 172.326C98.3245 172.326 71.875 177.109 71.875 196.23C71.875 215.364 98.1562 220.312 129.292 220.312C160.259 220.312 186.709 215.529 186.709 196.409C186.709 177.274 160.427 172.326 129.292 172.326Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M129.289 154.1C150.38 154.1 167.282 137.548 167.282 116.894C167.282 96.2395 150.38 79.6875 129.289 79.6875C108.206 79.6875 91.2969 96.2395 91.2969 116.894C91.2969 137.548 108.206 154.1 129.289 154.1Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M182.598 117.566C182.598 128.084 179.373 137.898 173.715 146.051C173.127 146.889 173.647 148.019 174.671 148.199C176.093 148.431 177.553 148.573 179.044 148.604C193.874 148.985 207.183 139.635 210.859 125.554C216.31 104.66 200.318 85.8994 179.946 85.8994C177.737 85.8994 175.619 86.1239 173.555 86.5357C173.273 86.5956 172.966 86.7304 172.814 86.9699C172.615 87.2768 172.76 87.6736 172.958 87.9356C179.082 96.3426 182.598 106.576 182.598 117.566Z",
    fill: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.392 174.761C223.679 169.094 217.127 165.209 207.159 163.3C202.458 162.177 189.723 160.583 177.881 160.807C177.706 160.83 177.606 160.949 177.591 161.024C177.568 161.144 177.622 161.323 177.851 161.451C183.324 164.101 204.476 175.63 201.816 199.944C201.702 201.008 202.565 201.906 203.643 201.756C208.849 201.03 222.241 198.208 226.392 189.434C228.694 184.793 228.694 179.403 226.392 174.761Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesEmpty);
export default __webpack_public_path__ + "static/media/employeesEmpty.89c6871fde2cc40969e62d224a64d03c.svg";
export { ForwardRef as ReactComponent };